// tracker.ts

import type {
  AiChatErrorProperties,
  AiChatPerformanceProperties,
  AiChatSideEffectProperties,
  AiChatWarningProperties,
  ProjectLaunchErrorProperties,
  EventType,
  TerminalErrorProperties,
  StoryboardNonResponsiveProperties,
  ClaudeCodeAuthProperties,
  MCPProperties,
} from "./types";
import posthog from "posthog-js";
import { toast } from "sonner";

interface EventPropertiesMap {
  AI_CHAT_SIDE_EFFECT: AiChatSideEffectProperties;
  AI_CHAT_ERROR: AiChatErrorProperties;
  AI_CHAT_WARNING: AiChatWarningProperties;
  AI_CHAT_PERFORMANCE: AiChatPerformanceProperties;
  PROJECT_LAUNCH_ERROR: ProjectLaunchErrorProperties;
  TERMINAL_WRITE_ERROR: TerminalErrorProperties;
  STORYBOARD_NON_RESPONSIVE: StoryboardNonResponsiveProperties;
  CLAUDE_CODE_AUTH: ClaudeCodeAuthProperties;
  MCP: MCPProperties;
}

type EventProperties<T extends EventType> =
  | (T extends keyof EventPropertiesMap
      ? EventPropertiesMap[T]
      : Record<string, any>)
  | undefined;

export function track<T extends EventType>(
  eventType: T,
  properties: EventProperties<T> = {} as EventProperties<T>,
): void {
  if (import.meta.env.VITE_ENVIRONMENT !== "DEV") {
    posthog.capture(eventType, properties);
  } else {
    console.log("posthog event", eventType, properties);
  }
}

// Create a wrapper function
const originalToastError = toast.error;
function customToastError(message, options) {
  // Add your additional functionality here
  track("TOAST_ERROR", { message }); // Example: log the error to an external service

  // Call the original toast.error function
  return originalToastError(message, options);
}

export const originalConsoleError = console.error;
if (import.meta.env.VITE_ENVIRONMENT !== "DEV" && !import.meta.env.VITE_TEMPO) {
  const customConsoleError = (message) => {
    try {
      track("CONSOLE_ERROR", {
        message: message?.toString?.() ?? "Unknown error",
      });
    } catch (e) {}
    originalConsoleError(message);
  };

  console.error = customConsoleError;
}

toast.error = customToastError;
